export const RIYOHOHO_OPTIONS = [
  { value: 'まずはお試しで登録してみた', label: 'まずはお試しで登録してみた' },
  { value: '今後の採用活動に使用することを検討している', label: '今後の採用活動に使用することを検討している' },
  { value: 'イベントを掲載したいため', label: 'イベントを掲載したいため' },
];

export const OSHIRI_OPTIONS = [
  { value: 'Yahoo!/Googleの検索', label: 'Yahoo!/Googleの検索' },
  { value: 'Twitter/FacebookなどのSNSから', label: 'Twitter/FacebookなどのSNSから' },
  { value: '口コミ/企業からの紹介', label: '口コミ/企業からの紹介' },
  { value: 'READY TO FASHIONからの案内', label: 'READY TO FASHIONからの案内' },
  { value: 'クリーデンスの紹介', label: 'クリーデンスの紹介' },
  { value: 'その他', label: 'その他' },
];
